import React, { forwardRef } from 'react';
import MUIAccordion, {
  AccordionProps as MUIAccordionProps,
} from '@material-ui/core/Accordion';

interface AccordionProps extends MUIAccordionProps {}

const Accordion = forwardRef<React.ReactElement, AccordionProps>(
  (props, ref) => {
    return <MUIAccordion {...props} ref={ref} />;
  }
);

export default Accordion;
